export default "__VITE_ASSET__DQxer0hZ__"